exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timeline-item {\n  background: #fff;\n}\n\n@keyframes placeHolderShimmer {\n  0% {\n    background-position: -100% 0\n  }\n  100% {\n    background-position: 200% 0\n  }\n}\n\n.animated-background {\n  animation-duration: 4s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: placeHolderShimmer;\n  animation-timing-function: linear;\n  background: #f6f7f8;\n  background: linear-gradient(to right, #eeeeee 16%, #dddddd 36%, #eeeeee 66%);\n  background-size: 50%;\n  height: 400px;\n  position: relative;\n}\n\n.background-masker {\n  background: #fff;\n  position: absolute;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/loaders/loader-image/loader-image.component.css
// module id = ../../../../../src/app/components/loaders/loader-image/loader-image.component.css
// module chunks = main